import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function TreatmentPlan({ item, index }) {
  return <QuestionHOC item={item} index={index}>
    <div className="row">
      <div className="col">
        <p className="mt-3" style={{ fontSize: 18, fontWeight: 'bold' }}>Treatment Plan</p>
        <p>Jane Doe, I am glad to hear you are doing well. The photograph shows that your wound is healing well. At this point I would recommend that you perform a daily low impact aerobic exercise activity such as a brisk walk stationary bike or treadmill. Avoid any lifting greater than 10 pounds.</p>
      </div>
    </div>
  </QuestionHOC>
}